import { useTranslation } from "react-i18next";

import { useState } from "react";

import { useSelector } from "react-redux";

import { usePageTitle } from "@/utils/usePageTitle";

import { useGetIndustriesQuery } from "@/pages/Private/redux/industry/industry.api";

import { industrySelector } from "@/pages/Private/redux/industry/industry.slice";

import EditableIndustryList from "./components/EditableIndustryList";

export default function ManageIndustries() {
	const { isLoading: isLoadingInitialData } = useGetIndustriesQuery();
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-industries.${key}`);
	const industries = useSelector(industrySelector);
	const [editingIndustryId, setEditingIndustryId] = useState(-1);

	usePageTitle(ts("title"));

	return (
		<div className="p-6">
			<EditableIndustryList
				data={industries}
				editingIndustryId={editingIndustryId}
				isLoading={isLoadingInitialData}
				setEditingIndustryId={setEditingIndustryId}
			/>
		</div>
	);
}
